var a={isInvalid:Boolean,isRequired:Boolean,isDisabled:Boolean,isReadOnly:Boolean};export{a as f};
